import { HoverElement } from "./HoverElement";
import { select, selectAll } from "d3";

export class BarHover extends HoverElement {
  constructor(params) {
    super({ ...params });
    // Local Attributes
    this.yField = params.yField;
    this.customName = params.customName;
    this.fillColor = params.fillColor;
    this.strokeColor = params.strokeColor || "colorSel";
    this.toZero = params.toZero;
    this.create({ ...params });
  }

  show({
    xPix,
    selData,
    candleWidth,
    highlightCandles,
    className,
    customName
  }) {
    let yt = this.svg.y;
    if (candleWidth) {
      if (highlightCandles) {
        select("." + this.className)
          .style("opacity", 1)
          .attr("x", xPix - candleWidth / 2)
          .attr("y", Math.min(yt(0), yt(selData[this.yField])))
          .attr(
            "height",
            Math.max(1, Math.abs(yt(0) - yt(selData[this.yField])))
          )
          .attr("width", candleWidth);
      } else {
        select("." + this.className).style("opacity", 0);
      }
    } else {
      selectAll(`.sticks${customName} *`).classed("hoved", false);
      selectAll(`.sticks2${customName} *`).classed("hoved", false);
      selectAll(`.candles${customName} *`).classed("hoved", false);

      select(`.stick${className}`).classed("hoved", true);
      select(`.stick2${className}`).classed("hoved", true);
      select(`.candle${className}`).classed("hoved", true);
    }
  }

  recalculate({ data, candleWidth, yt, xt, customNameBar }) {
    const _this = this;
    this.svg[customNameBar] = this.svg[customNameBar]
      .data(
        data.filter(d => d[_this.yField]),
        d => d.id
      )
      .join(
        function(enter) {
          return enter
            .append("rect")
            .attr("x", d => xt(d.date) - candleWidth / 2)
            .attr("width", candleWidth)
            .attr("y", d => {
              if (_this.toZero) {
                return Math.min(yt(0), yt(d[_this.yField]));
              } else {
                return yt(d[_this.yField]);
              }
            })
            .attr("height", d => {
              if (_this.toZero) {
                return Math.max(1, Math.abs(yt(0) - yt(d[_this.yField])));
              } else {
                return 1;
              }
            })
            .attr("stroke", function(d) {
              return d[_this.strokeColor];
            })
            .style("fill", function(d) {
              return d[_this.fillColor];
            })
            .style("shape-rendering", "crispEdges")
            .style("vector-effect", "non-scaling-stroke");
        },
        function(update) {
          return update
            .attr("x", d => xt(d.date) - candleWidth / 2)
            .attr("width", candleWidth)
            .attr("y", d => {
              if (_this.toZero) {
                return Math.min(yt(0), yt(d[_this.yField]));
              } else {
                return yt(d[_this.yField]);
              }
            })
            .attr("height", d => {
              if (_this.toZero) {
                return Math.max(1, Math.abs(yt(0) - yt(d[_this.yField])));
              } else {
                return 1;
              }
            })
            .style("shape-rendering", "crispEdges")
            .style("vector-effect", "non-scaling-stroke");
        },
        function(exit) {
          return exit.remove();
        }
      );
    return this.svg;
  }

  create({ strokeColor, strokeWidth = 1 }) {
    this.className = "bar" + this.customName;
    this.svg.bar = this.svg.append("g");
    this.svg.bar
      .append("rect")
      .attr("class", this.className)
      .style("opacity", 0)
      .attr("stroke", strokeColor)
      .attr("stroke-width", strokeWidth)
      .style("shape-rendering", "crispEdges")
      .attr("x", 0)
      .attr("y", 0)
      .attr("width", 0)
      .attr("height", 0);
  }
}
